import { Types } from '../../../constants';
import { BuiltinInstanceOf } from '../../BuiltinInstanceOf';
import { BuiltinInterface } from '../../BuiltinInterface';
import { ForwardValueAs } from './ForwardValueAs';
class ForwardValueInterface extends BuiltinInterface {
}
class ForwardValueValue extends BuiltinInstanceOf {
    constructor() {
        super(...arguments);
        this.type = 'ForwardValueConstructor';
    }
    emitInstanceOf(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.visit(node, options);
        if (optionsIn.pushValue) {
            sb.emitHelper(node, options, sb.helpers.isForwardValue);
            sb.emitHelper(node, options, sb.helpers.wrapBoolean);
        }
        else {
            sb.emitOp(node, 'DROP');
        }
    }
}
class ForwardValueConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addContractInterface('ForwardValue', new ForwardValueInterface());
    builtins.addContractValue('ForwardValue', new ForwardValueValue());
    builtins.addContractMember('ForwardValue', 'asString', new ForwardValueAs(Types.String));
    builtins.addContractMember('ForwardValue', 'asStringNullable', new ForwardValueAs(Types.String, true));
    builtins.addContractMember('ForwardValue', 'asNumber', new ForwardValueAs(Types.Number));
    builtins.addContractMember('ForwardValue', 'asNumberNullable', new ForwardValueAs(Types.Number, true));
    builtins.addContractMember('ForwardValue', 'asBoolean', new ForwardValueAs(Types.Boolean));
    builtins.addContractMember('ForwardValue', 'asBuffer', new ForwardValueAs(Types.Buffer));
    builtins.addContractMember('ForwardValue', 'asBufferNullable', new ForwardValueAs(Types.Buffer, true));
    builtins.addContractMember('ForwardValue', 'asAddress', new ForwardValueAs(Types.Buffer));
    builtins.addContractMember('ForwardValue', 'asAddressNullable', new ForwardValueAs(Types.Buffer, true));
    builtins.addContractMember('ForwardValue', 'asHash256', new ForwardValueAs(Types.Buffer));
    builtins.addContractMember('ForwardValue', 'asHash256Nullable', new ForwardValueAs(Types.Buffer, true));
    builtins.addContractMember('ForwardValue', 'asPublicKey', new ForwardValueAs(Types.Buffer));
    builtins.addContractMember('ForwardValue', 'asPublicKeyNullable', new ForwardValueAs(Types.Buffer, true));
    builtins.addContractMember('ForwardValue', 'asArray', new ForwardValueAs(Types.Array));
    builtins.addContractMember('ForwardValue', 'asArrayNullable', new ForwardValueAs(Types.Array, true));
    builtins.addContractMember('ForwardValue', 'asMap', new ForwardValueAs(Types.Map));
    builtins.addContractMember('ForwardValue', 'asMapNullable', new ForwardValueAs(Types.Map, true));
    builtins.addContractInterface('ForwardValueConstructor', new ForwardValueConstructorInterface());
};

//# sourceMappingURL=index.js.map
